import { render, staticRenderFns } from "./chooseImg.vue?vue&type=template&id=87dd8f70&scoped=true&"
import script from "./chooseImg.vue?vue&type=script&lang=js&"
export * from "./chooseImg.vue?vue&type=script&lang=js&"
import style0 from "./chooseImg.vue?vue&type=style&index=0&id=87dd8f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dd8f70",
  null
  
)

export default component.exports